import { render, staticRenderFns } from "./almondco-freight-label-create.vue?vue&type=template&id=3c0c7f6f&"
import script from "./almondco-freight-label-create.vue?vue&type=script&lang=js&"
export * from "./almondco-freight-label-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports